/*
  Image aspect ratios hold different sizes for different layouts
  ContentTileAspectRatioSizes holds two layout options:
    - twoTileLayout
    - fourTileLayout
*/

import { Breakpoint } from '@noths/polaris-client-ribbons-base';

import type { AspectRatioSizeSetType } from './types';

export const ContentTileAspectRatioSizes = {
  fourTileLayout: [
    {
      breakpoint: Breakpoint.XL,
      imgs: [
        {
          width: 350,
          aspectRatio: '4:3',
        },
        {
          width: 700,
          aspectRatio: '4:3',
        },
      ],
    },
    {
      breakpoint: Breakpoint.L,
      imgs: [
        {
          width: 542,
          aspectRatio: '4:3',
        },
        {
          width: 1084,
          aspectRatio: '4:3',
        },
      ],
    },
    {
      breakpoint: Breakpoint.S,
      imgs: [
        {
          width: 350,
          aspectRatio: '4:3',
        },
        {
          width: 700,
          aspectRatio: '4:3',
        },
      ],
    },
    {
      breakpoint: Breakpoint.XS,
      imgs: [
        {
          width: 180,
          aspectRatio: '4:3',
        },
        {
          width: 360,
          aspectRatio: '4:3',
        },
      ],
    },
  ] as AspectRatioSizeSetType[],
  twoTileLayout: [
    {
      breakpoint: Breakpoint.XL,
      imgs: [
        {
          width: 566,
          height: 303,
          aspectRatio: '16:9',
        },
        {
          width: 1132,
          height: 606,
          aspectRatio: '16:9',
        },
      ],
    },
    {
      breakpoint: Breakpoint.L,
      imgs: [
        {
          width: 464,
          height: 303,
          aspectRatio: '3:2',
        },
        {
          width: 928,
          height: 606,
          aspectRatio: '3:2',
        },
      ],
    },
    {
      breakpoint: Breakpoint.M,
      imgs: [
        {
          width: 358,
          height: 175,
          aspectRatio: '2:1',
        },
        {
          width: 716,
          height: 350,
          aspectRatio: '2:1',
        },
      ],
    },
    {
      breakpoint: Breakpoint.S,
      imgs: [
        {
          width: 316,
          height: 238,
          aspectRatio: '4:3',
        },
        {
          width: 632,
          height: 476,
          aspectRatio: '4:3',
        },
      ],
    },
    {
      breakpoint: Breakpoint.XS,
      imgs: [
        {
          width: 158,
          height: 119,
          aspectRatio: '4:3',
        },
        {
          width: 316,
          height: 238,
          aspectRatio: '4:3',
        },
      ],
    },
  ] as AspectRatioSizeSetType[],
};
